module.exports = __webpack_public_path__ + "img/insta-icon.8fb545f.svg";